<template>
  <div>
    <vue-headful title="Credimóvil | Aviso de privacidad" />
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area banner_area_5">
      <div class="container">
        <h6></h6>
        <h2>AVISO DE PRIVACIDAD</h2>
        <ol class="breadcrumb">
          <li></li>
          <li></li>
        </ol>
      </div>
    </section>
    <!-- Banner Area -->

    <!-- Achieve your financial -->
    <section class="achieve_financial_area afa_2">
      <div class="container">
        <div class="aviso-de-privacidad-text text-justify">

          <div class=" text-center">

            <h3 class="ft13Black">AVISO DE PRIVACIDAD</h3>
            <h4 class="ft13Black">“GPI, AUTO COMERCIAL, S.A.P.I. DE C.V.”</h4>
          </div>
          <br>
          <p class="pb-3">El presente aviso de privacidad queda bajo tutela y protección de
            <strong>“GPI, AUTO COMERCIAL, S.A.P.I. DE C.V.”</strong>
            , en adelante <strong>“GPI”</strong>, siendo responsable sobre
            todos
            los derechos y obligaciones declarados
            en el presente aviso.
          </p>

          <p class="pb-3">
            <strong>“GPI” </strong>
            con domicilio en Calle Av. Las Rosas no. 2991 Colonia Chapalita en Guadalajara, Jalisco C.P. 44510, de
            conformidad en lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de Particulares
            y su Reglamento, en adelante denominados conjuntamente como la “Ley”, emite el Presente Aviso de Privacidad
            en los siguientes términos:
          </p>

          <b class="pb-3 ft10Black">REPONSABLES DE LOS DATOS PERSONALES</b>

          <p class="pb-3">
            <strong>“GPI”</strong> es el responsable en los términos de la Ley de la obtención, divulgación,
            almacenamiento, uso, manejo
            y transferencia de los datos personales que recabe de cualquier persona física en adelante los
            <strong>“Titulares”</strong>.
            <br> <br>
            Le hacemos saber que “GPI, AUTO COMERCIAL, S.A.P.I. DE C.V.”, dará trámite a las solicitudes relativas a
            datos personales y fomentará la protección de datos personales al interior de “GPI”, usted puede ubicar y
            contactar directamente en nuestras oficinas ubicadas en la dirección señalada al inicio del presente aviso o
            bien en la siguiente cuenta de correo electrónico atencioncliente@gpiautocomercial.com.mx.
          </p>
          <p class="pb-3">
          <ul>
            <li><strong>Le informamos que GPI podrá recopilar su información de diversas maneras, entre ellas:</strong>
            </li>
            <ol>
              <li><strong>1.-</strong>  Personalmente: Cuando usted solicita o adquiere cualquiera de los servicios
                financieros proporcionados en la sucursal de la dirección antes mencionada.</li>
              <li><strong>2.-</strong> Directa: Cuando nos proporcione sus datos personales para solicitar nuestros
                servicios financieros, a través de nuestra página en internet o redes sociales como Instagram o Facebook
                (a través de nuestro Asistente virtual “ChatBot”) o vía telefónica.</li>
              <li><strong>3.-</strong> Indirecta: De cualquier otra fuente de información comercialmente disponible o
                que sean permitidas por la Ley.</li>
            </ol>
          </ul>
          </p>

          <p class="pb-3">La información que recabamos de usted puede combinarse con la finalidad de ayudarnos en el
            ofrecimiento, prestación y/o mejora de nuestros servicios financieros.</p>
          <p class="pb-3">Le informamos que <strong>“GPI”</strong> no recaba datos sensibles como consecuencia de los
            servicios.</p>

          <b class="pb-3">DATOS PERSONALES RECABADOS.</b>
          <p class="pb-3 pl-4">
          <ul>
            <li style="list-style-type:disc"><strong>Datos Personales</strong></li>
            <ol>
              <li style="list-style-type:circle"> Fecha de nacimiento, Sexo, Estado Civil, Nacionalidad, Educación,
                dependientes económicos y demás relacionados.</li>
            </ol>
            <li style="list-style-type:disc"><strong>Datos de Identificación</strong></li>
            <ol>
              <li style="list-style-type:circle">RFC, CURP</li>
            </ol>
            <li style="list-style-type:disc"><strong>Datos Laborales;</strong></li>
            <li style="list-style-type:disc"><strong>Datos Financieros,</strong></li>
            <ol>
              <li style="list-style-type:circle">Ingresos, Estados de Cuenta y demás relacionados</li>
            </ol>
            <li style="list-style-type:disc"><strong>Datos Patrimoniales.</strong></li>
            <ol>
              <li style="list-style-type:circle">Bienes Materiales, Inmuebles y demás relacionados</li>
            </ol>

          </ul>
          </p>

          <b class="pb-3">DATOS PERSONALES SENSIBLES RECABADOS</b>

          <p class="pb-3">
          <ul>
            <li><strong>En el caso de Datos Sensibles tales como:</strong></li>
            <ol>
              <li><strong>1. </strong>Datos Financieros (Ingresos, Estados de Cuenta y demás relacionados)</li>
              <li><strong>2. </strong>Datos Patrimoniales (Bienes Materiales, Inmuebles y demás relacionados)</li>
              <li><strong>3. </strong>Datos Personales (Cónyuge, Estado Civil, Nacionalidad, Educación, Hijos y demás
                relacionados)</li>
              <li><strong>4. </strong>Referencias familiares y no familiares (Nombre, Dirección, Teléfono, relación,
                etc.)</li>
            </ol>
            <li><strong>Estos serán utilizados única y exclusivamente para:</strong></li>
            <ol>
              <li><strong>1. </strong>Investigación y Obtención de Créditos ante las instituciones Financieras.</li>
            </ol>
          </ul>
          </p>

          <b class="pb-3">FINALIDADES A QUE SE SUJETARÁ EL TRATAMIENTO DE DATOS PERSONALES</b>

          <p class="pb-3">El tratamiento de datos personales del titular, salvo que este disponga lo contrario
            utilizando los medios descritos en el presente Aviso de Privacidad, tiene como finalidad, el dar a conocer
            nuestros servicios financieros, y cumplimiento de nuestros términos y condiciones en la prestación dedichos
            servicios.</p>

          <p class="pb-3">
            Las partes acuerdan que el Cliente podrá expresar su consentimiento respecto al presente (contrato/términos
            y condiciones, convenio, etc.), así como tener acceso a los servicios ofrecidos por cualquiera de las
            sociedades de crédito que operan en el país mediante medios electrónicos tales como NIP.
          </p>

          <p class="pb-3">
            Autorizo expresamente a (Otorgante de Crédito), para lleve a cabo Investigaciones sobre mi comportamiento
            Crediticio en las Sociedades de Información Crediticia (SIC) que estime conveniente. Conozco la naturaleza y
            alcance de la información que se solicitará, del uso se le dará y que se podrán realizar consultas
            periódicas de mi historial crediticio. Consiento que esta autorización tenga una vigencia de 3 años contados
            a partir de hoy, y en su caso mientras mantengamos relación jurídica. Acepto que este documento quede bajo
            propiedad de (Otorgante de Crédito y/o SIC Consultada) para efectos de control y cumplimiento del artículo
            28 de la LRSIC."
          </p>

          <b class="pb-3">FINALIDADES SECUNDARIAS</b>

          <p class="pb-3">Realizar actividades de mercadotecnia, publicidad, promoción y telemarketing, de los bienes,
            productos y/o servicios que sean ofrecidos, por cualquier medio material y/o electrónico.</p>

          <p class="pb-3"><b>MEDIOS PARA EL EJERCICIO DE DERECHOS ARCO DEL TITULAR.</b>
            El titular de datos personales podrá ejercer sus derechos de negación, acceso, rectificación, cancelación y
            oposición, en cualquier momento, a través del Área de Privacidad de GPI en los teléfonos (33)1078 2829 o
            bien a través de nuestro correo electrónico atencioncliente@gpiautocomercial.com.mx
          </p>

          <p class="pb-3">Si usted no manifiesta su oposición para que sus datos personales sean transferidos, se
            entenderá que ha otorgado su consentimiento para ello.</p>

          <p class="pb-3">Este aviso de privacidad podrá ser modificado por GPI, empresa perteneciente a
            <b>GPI AUTO COMERCIAL SAPI DE C.V.</b>, modificaciones serán oportunamente informadas a través de correo
            electrónico, teléfono o cualquier otro medio de comunicación que GPI, empresa perteneciente a
            <b>GPI AUTO COMERCIAL SAPI DE C.V.</b>, determine para tal efecto.
          </p>
        </div>
      </div>
    </section>
    <!-- Achieve your financial -->
  </div>
</template>

<script>
export default {
  name: 'PrivacyNotice'
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/PrivacyNotice.vue